import { render, staticRenderFns } from "./AtualizarProdutoDialog.vue?vue&type=template&id=715bf356&"
import script from "./AtualizarProdutoDialog.vue?vue&type=script&lang=js&"
export * from "./AtualizarProdutoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports